import { render, staticRenderFns } from "./Macros-Diarios.vue?vue&type=template&id=4c798cf6&scoped=true&"
import script from "./Macros-Diarios.vue?vue&type=script&lang=ts&"
export * from "./Macros-Diarios.vue?vue&type=script&lang=ts&"
import style0 from "./Macros-Diarios.vue?vue&type=style&index=0&id=4c798cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c798cf6",
  null
  
)

export default component.exports